/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Faq_1_AInputs */

const en_vc_faq_1_a = /** @type {(inputs: Vc_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. VectorCraft is open source under your choice of the MIT or Apache-2.0 license. There is no subscription, trial or account, and you can use it for commercial work.`)
};

const zh_vc_faq_1_a = /** @type {(inputs: Vc_Faq_1_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费。VectorCraft 以 MIT 或 Apache-2.0 协议开源（二选一）。没有订阅、没有试用期、不用注册账号，也可以用于商业项目。`)
};

/**
* | output |
* | --- |
* | "Yes. VectorCraft is open source under your choice of the MIT or Apache-2.0 license. There is no subscription, trial or account, and you can use it for commer..." |
*
* @param {Vc_Faq_1_AInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_faq_1_a = /** @type {((inputs?: Vc_Faq_1_AInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Faq_1_AInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_faq_1_a(inputs)
	return zh_vc_faq_1_a(inputs)
});
export { vc_faq_1_a as "vc.faq.1.a" }